import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const InfoIconCustom = styled.div<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  color: ${({ colorIcon }) => colorIcon || COLORS.gray};
  cursor: ${({ cursor, disabled }) =>
    cursor && !disabled ? cursor : 'default'};

  path {
    fill: ${({ colorIcon }) => colorIcon || COLORS.black};
    ${({ disabled }) => disabled && `fill: ${COLORS.gray};`}
  }
`
